export function replaceElement(
    result: any,
    itemSpecsElement: any,
    itemId: any,
    itemType: string
) {
    const $: any = (<any>window).$;

    if (result) {
        if (itemSpecsElement.attr("data-lockreplacement") !== "true") {
            itemSpecsElement.replaceWith(result);
        } else {
            const replacements: Array<any> = (
                result instanceof $ ? result : $(result)
            ).find("[data-important-replace]");
            itemSpecsElement
                .find("[data-important-replace]")
                .each((p: any, e: any) => {
                    const itemToReplace = $(e);
                    const replacement = replacements.filter(function (
                        this: any
                    ) {
                        return (
                            $(this).attr("data-important-replace") ===
                            itemToReplace.attr("data-important-replace")
                        );
                    });
                    //console.log(itemToReplace, replacement);
                    if (replacement != null)
                        itemToReplace.replaceWith(replacement);
                });
        }
    } else {
        // We remove it from the list if the bidding has ended.
        const productInListElement = itemSpecsElement.parents(
            ".auction-productItem[id='" + itemId + "']"
        );
        if (itemType == "product" && productInListElement.length > 0)
            productInListElement.remove();
    }
}
